// extracted by mini-css-extract-plugin
module.exports = {"subpageNav__link":"SubpageNav-module--subpage-nav__link--1xThB","subpageNav__icon":"SubpageNav-module--subpage-nav__icon--2Cvgu"};